<template>
    <div>
        <div v-show="!procesando" class="row">
            <div class="col-xl-2 col-lg-2">
                <a :href="URL_WEB() + 'certificado/' + tipo + '/' + Id + '/1'" target="_blank"
                    class="btn btn-lg btn-block btn-white">
                    <span class="d-flex align-items-center text-center">
                        <i class="fa fa-print fa-3x me-3 text-black"></i> &nbsp;
                        IMPRIMIR FORMATO DE CONFORMIDAD

                    </span>
                    <small> (GASOLINA
                            CONVERSION
                            INICIAL
                            APERTURA)</small>
                </a>
            </div>
            <div v-show="this.$store.state.usuario.idtipo == '2'" class="col-xl-2 col-lg-2">
                <a :href="URL_WEB() + 'certificado/' + tipo + '/' + Id + '/1/1'" target="_blank"
                    class="btn btn-lg btn-block btn-white">
                    <span class="d-flex align-items-center text-center">
                        <i class="fa fa-print fa-3x me-3 text-black"></i> &nbsp;
                        FORMATO DE CONFORMIDAD CON IMAGEN
                    </span>
                </a>
            </div>
            <div class="col-xl-2 col-lg-2" v-show="pdf1 != '' && pdf1 != undefined && pdf1 != '#'">
                <a :href="URL_WEB() + pdf1" target="_blank" class="btn btn-lg btn-block btn-white">
                    <span class="d-flex align-items-center text-center">
                        <i class="fas fa-file-pdf fa-3x me-3 text-black"></i> &nbsp;
                        CERTIFICADO CONFORMIDAD
                    </span>
                </a>

            </div>
            <div v-if="tipo != 'modificacion'"
                :class="{ 'col-xl-2 col-lg-2': pdf1 != '' && pdf1 != undefined && pdf1 != '#', ' col-xl-2 col-lg-2 offset-xl-2 offset-lg-2': pdf1 == '' || pdf1 == undefined || pdf1 == '#' }">

                <a :href="URL_WEB() + 'certificado/' + tipo + '/' + Id + '/2'" target="_blank"
                    class="btn btn-lg btn-block btn-white">
                    <span class="d-flex align-items-center text-center">
                        <i class="fa fa-print fa-3x me-3 text-black"></i> &nbsp;
                        IMPRIMIR FORMATO DE INSPECCIÓN 
                        

                    </span>
                  <small>Anual</small>
                </a>
                <a v-show="tipo == 'gnv'" :href="URL_WEB() + 'certificado/' + tipo + '_actual/' + Id + '/2'"
                    target="_blank" class="btn btn-lg btn-block btn-white">
                    <span class="d-flex align-items-center text-center">
                        <i class="fa fa-print fa-3x me-3 text-black"></i> &nbsp;
                        F. I. ACTUAL
                    </span>
                </a>
            </div>
            <div v-show="this.$store.state.usuario.idtipo == '2'" v-if="tipo != 'modificacion'"
                class="col-xl-2 col-lg-2">

                <a :href="URL_WEB() + 'certificado/' + tipo + '/' + Id + '/2/1'" target="_blank"
                    class="btn btn-lg btn-block btn-white">
                    <span class="d-flex align-items-center text-center">
                        <i class="fa fa-print fa-3x me-3 text-black"></i> &nbsp;
                        FORMATO DE INSPECCIÓN CON IMAGEN
                    </span>
                </a>
            </div>

            <div v-if="tipo != 'modificacion'" class="col-xl-2 col-lg-2"
                v-show="pdf2 != '' && pdf2 != undefined && pdf2 != '#'">


                <a :href="URL_WEB() + pdf2" target="_blank" class="btn btn-lg btn-block btn-white">
                    <span class="d-flex align-items-center text-center">
                        <i class="fas fa-file-pdf fa-3x me-3 text-black"></i> &nbsp;
                        CERTIFICADO INSPECCIÓN
                    </span>
                </a>
            </div>

        </div>
        <br>
        <div class="row">
            <div class="col-xl-3 col-lg-3">

                <b-file v-model="pdf.pdf1Archivo" browse-text="Seleccionar" accept=".pdf"
                    placeholder="Ningún archivo seleccionado"></b-file>


            </div>
            <div class="col-xl-3 col-lg-3">
                <button type="button" @click="uploadPdf1()" class="btn btn-warning btn-sm btn-block"><i
                        class="fa fa-upload"></i> Subir Certificado de Conformidad</button>
            </div>
            <div v-if="tipo != 'modificacion'" class="col-xl-3 col-lg-3">
                <b-file v-model="pdf.pdf2Archivo" browse-text="Seleccionar" accept=".pdf"
                    placeholder="Ningún archivo seleccionado"></b-file>

            </div>
            <div v-if="tipo != 'modificacion'" class="col-xl-3 col-lg-3">
                <button type="button" @click="uploadPdf2()" class="btn btn-warning btn-sm btn-block"><i
                        class="fa fa-upload"></i> Subir Certificado de Inspección Anual</button>
            </div>
        </div>
        <procesando v-show="procesando" :tipo="1" :texto="'Subiendo archivo...'" />
    </div>

</template>

<script>
import procesando from '../compartidos/Procesando.vue'
import axios from 'axios'

export default {
    name: "Paso3Component",
    components: {
        procesando
    },

    data() {
        return {
            procesando: false,
            pdf: {
                pdf1: "",
                pdf2: "",
                pdf1Archivo: null,
                pdf2Archivo: null,
            }
        }
    },
    props: ["Id", "pdf1", "pdf2", "url", "tipo"],
    methods: {
        uploadPdf1() {
            if (this.pdf.pdf1Archivo != null) {
                this.procesando = true;
                let formdata = new FormData();
                formdata.append("archivo", this.pdf.pdf1Archivo);
                axios.post(this.url + '/pdf1/' + this.Id, formdata).then((respuesta) => {
                    if (respuesta.data.msg == "exito") {

                        this.completarPaso3();
                    }
                    this.procesando = false;
                }).catch(function (error) {
                    this.mostrarErrorFatal(error);
                    this.procesando = false;
                });
            }

        },
        uploadPdf2() {
            this.procesando = true;
            let formdata = new FormData();
            formdata.append("archivo", this.pdf.pdf2Archivo);
            axios.post(this.url + '/pdf2/' + this.Id, formdata).then((respuesta) => {
                if (respuesta.data.msg == "exito") {

                    this.completarPaso3();
                }
                this.procesando = false;
            }).catch(function (error) {
                this.mostrarErrorFatal(error);
                this.procesando = false;
            });
        },
        completarPaso3() {
            this.$swal('Carga completada', '', 'success');
            this.$emit('completado');

        }

    },
    watch: {
        Id(newQuestion, oldQuestion) {
            this.Id = newQuestion;
        },
        pdf1(newQuestion, oldQuestion) {
            this.pdf1 = newQuestion;
        },
        pdf2(newQuestion, oldQuestion) {
            this.pdf2 = newQuestion;
        },
    }
}
</script>